import React from 'react';
import TweenOne from 'rc-tween-one';
import QueueAnim from 'rc-queue-anim';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '../../utils';

/* replace-start */
import './index.less';
/* replace-end */
class Banner7 extends React.PureComponent {
  render() {
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;

    return (
      <OverPack
        {...tagProps}
        {...dataSource.wrapper}
      >
        <div {...dataSource.bg} data-edit="image">
          <img src={dataSource.bg.children} width="100%" alt="img" />
        </div>
        <div
          {...dataSource.page}
        >
          <div
            className="content"
          >
            <TweenOne
              animation={{
                x: 0,
                duration: 300,
              }}
              style={{ transform: 'translateX(-200px)' }}
              key="logo"
              {...dataSource.logo}
              data-edit="image"
            >
              <img src={dataSource.logo.children} width="100%" alt="img" />
            </TweenOne>
            <QueueAnim
              type="scaleY"
              delay={200}
              className="box"
            >
              {
                dataSource.main.children.map(getChildrenToRender)
              }
            </QueueAnim>
          </div>
        </div>
      </OverPack>
    );
  }
}
export default Banner7;
